/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinksByExpiration} from '../api'

 export const useQueryGetInstrumentLinksByExpiration = createReactQueryHook('getInstrumentLinksByExpiration', getInstrumentLinksByExpiration)
